import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import doctor_sample from '../assets/doctor_sample.jpg';
import { RxHeart, RxHeartFilled } from "react-icons/rx";
import { callApi, CDN_URL, formatMoneyShorten } from "../Helpers";
import { FaRegCommentDots } from "react-icons/fa";

export default function View({ data }) {
	const appContext = useContext(AppContext);

	const [isLiked, setIsLiked] = useState(false);
	const [numberOfLikes, setNumberOfLikes] = useState(0);


	function likesBuffer() {
		if(data) {
			return ((data.title.length) * 17);
		}

		return 121;
	}

	function view(e) {
		e.stopPropagation();

		appContext.navTo({
			item: 'view',
			subItem: 'confession',
			extraItem: data.id,
		});
	}

	async function like(e) {

		e.stopPropagation();

		if (!isLiked) {
			setIsLiked(true);
			setNumberOfLikes(_prev => Number(_prev) + 1)
			await callApi('like-confession', { id: data.id }).then(response => {
				if(response.status === 1) {
					//good action
				}
			})
		}
	}

	useEffect(() => {
		if(data) {
			const likes = JSON.parse(data.likes);
			setNumberOfLikes(likes.length + likesBuffer());

			if(appContext.auth && appContext.currentUserData) {
				for (const like of likes) {
					if(Number(like) === Number(appContext.currentUserData.id)) {
						setIsLiked(true);
						break;
					}
				}
			}
		}
	}, [data])

	return (
		<div
			
			style={{
				width: "100%",
				height: "320px",
				padding: "10px",
			}}
		>
			<img
				style={{
					height: "60%",
					width: "100%",
					objectFit: "cover",
					borderRadius: "20px",
					overflow: "none"
				}}
				src={CDN_URL+data.cover}
				className="mNoMargin"
				onClick={view}
			/>
			<h6
				className="mNoMargin font-semi-bold"
				style={{
					paddingTop: "5px",
					fontSize: "18px",
					height: "25%",
					overflow: "hidden",
					display: "-webkit-box", // Required for multiline ellipsis
					WebkitLineClamp: 3, // Limits text to 2 lines
					WebkitBoxOrient: "vertical", // Specifies vertical orientation
					lineHeight: "1.2em", // Line height to adjust spacing
				}}
				onClick={view}
			>
				{data.title}
			</h6>

			<div
				className="d-flex mNoMargin"
				style={{
					height: "15%",
					overflow: "hidden",
					paddingTop: "5px"
				}}
			>
				
				<div
					style={{
						width: "auto",
						flexShrink: "0",
						paddingRight: "20px",
					}}
					className="mNoMargin text-center text-secondary"
				>
					<h6
						onClick={like}
						className="mNoMargin"
					>
						{isLiked ? <RxHeartFilled size={28} /> : <RxHeart size={28} />}
					</h6>
					<h6
						style={{
							fontSize: "12px",
						}}
						className="mNoMargin text-secondary font-bold"
					>
						{formatMoneyShorten(numberOfLikes)}
					</h6>
				</div>

				<div
					style={{
						width: "auto",
						flexShrink: "0",
						paddingRight: "20px",
					}}
					className="mNoMargin text-center text-secondary"
				>
					<h6
						className="mNoMargin"
					>
						<FaRegCommentDots size={28} />
					</h6>
					<h6
						style={{
							fontSize: "12px",
						}}
						className="mNoMargin text-secondary font-bold"
					>
						{formatMoneyShorten(data.commentsCount)}
					</h6>
				</div>

				
			</div>

			
		</div>
	);
}
